import {
    CLEAR_ALL,
    GET_ROLES_REQUEST,
    GET_ROLES_SUCCESS,
    GET_ROLES_ERROR,
} from 'constants/ActionTypes';

const initialState = {
    list: [],
    listLoading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ROLES_REQUEST:
            return {
                ...state,
                listLoading: true,
            };
        case GET_ROLES_SUCCESS:
            return {
                ...state,
                listLoading: false,
                list: action.payload.rolesList || [],
            };
        case GET_ROLES_ERROR:
            return {
                ...state,
                listLoading: false,
                list: [],
            };
        case CLEAR_ALL:
            return initialState;
        default:
            // need this for default case
            return {
                ...state,
            };
    }
}
